import React from "react";
import { AppLayout } from "../components/layout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Map, HelpCircle, Settings2, ArrowRight } from "lucide-react";
import { useNavigateWithLock } from "../hooks/useNavigateWithLock";
import { useUserStore } from "../store/userStore";

const DashboardPage: React.FC = () => {
  const breadcrumbs = [
    { title: 'Dashboard', isCurrentPage: true }
  ];
  const navigate = useNavigateWithLock();
  const { account } = useUserStore();

  const quickActions = [
    {
      title: "Guides",
      description: "Create and manage step-by-step guides",
      icon: Map,
      url: "/guides",
      action: "View Guides",
      color: "text-blue-600"
    },
    {
      title: "Help Centers",
      description: "Manage your help center portals",
      icon: HelpCircle,
      url: "/help-centers",
      action: "View Help Centers",
      color: "text-purple-600"
    },
    {
      title: "Guide Branding",
      description: "Customize branding (name, logo, colors) for all guides",
      icon: Settings2,
      url: "/settings/guides-appearance",
      action: "Open Settings",
      color: "text-gray-600"
    }
  ];

  return (
    <AppLayout showSidebar={true} breadcrumbs={breadcrumbs}>
      <div className="space-y-6 p-4">
        {/* Welcome Section */}
        <div className="space-y-2">
          <h1 className="text-3xl font-bold tracking-tight">
            Welcome{account?.email ? `, ${account.email.split('@')[0]}` : ''}!
          </h1>
          <p className="text-muted-foreground">
            Manage your Folge Cloud help centers and guides.
          </p>
        </div>

        {/* Quick Actions Grid */}
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {quickActions.map((action) => {
            const Icon = action.icon;
            return (
              <Card key={action.title} className="hover:shadow-md transition-shadow">
                <CardHeader>
                  <div className="flex items-center gap-3">
                    <div className={`p-2 rounded-lg bg-muted ${action.color}`}>
                      <Icon className="h-5 w-5" />
                    </div>
                    <div className="flex-1">
                      <CardTitle className="text-lg">{action.title}</CardTitle>
                    </div>
                  </div>
                  <CardDescription className="mt-2">
                    {action.description}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <Button
                    variant="outline"
                    className="w-full"
                    onClick={() => navigate(action.url)}
                  >
                    {action.action}
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>

      </div>
    </AppLayout>
  );
};

export default DashboardPage;
